import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString } from '../../../util/shared/vue-global';

const { backend } = clients.direct;
const defaultCheckTaxPaymentBalToGLFields = {
  matchAmtFlag: '',
  date: '',
  taxAmt: '',
  runningTotal: '',
  gLBalance: '',
};

export const checkTaxPaymentBalanceToGL = {
  namespaced: true,
  actions: {
    async taxPaymentBalToGLGatherInformation({ commit, dispatch }, { criteria }) {
      let results;
      const gqlfields = defaultCheckTaxPaymentBalToGLFields;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`query
                    taxPaymentBalToGLGatherInformation ($criteria:taxPaymentBalToGLGatherInfoCriteriaType) {
                    taxPaymentBalToGLGatherInformation(criteria: $criteria){
                    ${fieldsToGqlString(gqlfields)}
                    },
                }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const result = results.data ? (results.data.taxPaymentBalToGLGatherInformation || {}) : {};
        // console.info(results.data, 'res');
        return result;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There is a problem while collecting gather information.', { root: true });
      }
      return null;
    },
  },
};
export default checkTaxPaymentBalanceToGL;
